export function displayPlan(plan) {
  if (plan === "team") return "operator";
  if (plan === "trial") return "hunter";
  return plan;
}

export function billingPlanState(user = {}, now = new Date()) {
  const account = user || {};
  const subscriptionPlan = account.plan?.toLowerCase() || "hunter";
  const subscriptionStatus = account.subscription_status;
  const trialEnd = account.trialEndsAt && new Date(account.trialEndsAt);
  const hasActiveTrialExpiration = trialEnd instanceof Date &&
    !Number.isNaN(trialEnd.getTime()) && trialEnd > now;
  const isTrial = typeof account.isTrial === "boolean"
    ? account.isTrial
    : subscriptionPlan === "trial";
  const hasActiveTrialStatus = subscriptionPlan === "trial"
    ? subscriptionStatus === "trialing"
    : subscriptionStatus === "active";
  const hasLiveSubscription = Boolean(
    account.hasStripeSubscription &&
    ["active", "trialing", "past_due"].includes(subscriptionStatus)
  );

  return {
    subscriptionPlan,
    displayTier: displayPlan(account.effectivePlan || subscriptionPlan),
    isTrial,
    isTrialActive: isTrial && hasActiveTrialStatus && hasActiveTrialExpiration,
    hasLiveSubscription,
  };
}

export function availableCheckoutPlans(plans, billing) {
  if (billing.isTrial) return plans;
  return plans.filter(plan => plan !== billing.displayTier);
}

export function checkoutPayload(plan, interval = "monthly") {
  return { plan, interval };
}
